<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList">
      <div slot="content-buttons">
        <Button
          _key="btnTaxationCreate"
          title="Serviço"
          classIcon="fas fa-plus-circle"
          type="primary"
          size="small"
          :clicked="create"
        />
      </div>
    </ViewTemplateConfiguration>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TaxationView",
  components: {
    ViewTemplateConfiguration,
    Button,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/tax-document/taxation/get-all",
        urlDeleteAllApi: "/api/v1/tax-document/taxation/delete",
        headerTable: [
          {
            field: "identificacao",
            title: "Identificação",
            type: "link",
            iconSearch: true,
            eventName: "taxationUpdate",
          },
          {
            field: "codigo",
            title: "Código Serviço",
            type: "text",
          },
          {
            field: "codigoTributacao",
            title: "Código Tributação",
            type: "text",
          },
          {
            field: "nbs",
            title: "NBS",
            type: "text",
          },
          {
            field: "cnae",
            title: "CNAE",
            type: "text",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "taxationCreate",
      });
      this.removeLoading(["btnTaxationCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "taxationUpdate") {
          this.$router.push({
            name: "taxationUpdate",
            params: { id: event.data.id },
          });
        }
      },
      deep: true,
    },
  },
};
</script>
